const inertiaLEDProductSpecs = {
  "0.937mm": [
    { label: "Pixel Pitch (mm)", value: "0.937mm" },
    { label: "Resolution (per cabinet)", value: "640*360" },
    {
      label: "Product Dimensions (mm, per cabinet)",
      value: "600 x 337.5 x 40",
    },
    { label: "Modules Array (W x H, per cabinet)", value: "4 x 1" },
    { label: "Weight (per cabinet)", value: "W6.5kg" },
    { label: "Aspect Ratio", value: "16:9" },
    { label: "Brightness (nits)", value: "600-800" },
    { label: "Contrast Ratio (typ)", value: "7000:1" },
    { label: "LED Pixel Type", value: "SMD1616 4in1 LED" },
    { label: "Viewing Angle", value: "160° H/V" },
    { label: "Cabinet Material", value: "Die-Casting Aluminum" },
    { label: "Color Temperature", value: "3200-9300K Adjustable" },
    { label: "Power Consumption - Max", value: "<650w/m²" },
    { label: "Power Consumption - Avg", value: "<150w/m²" },
    { label: "Input Power Voltage", value: "100-240VAC, 50/60Hz" },
    { label: "Power Redundancy", value: "Available" },
    { label: "Video Rate", value: "30-120Hz" },
    { label: "Refresh Rate", value: "1920~3840Hz" },
    { label: "Control System", value: "ATE IPS System" },
    { label: "Color Depth", value: "14-18 bit" },
    {
      label: "Operational Temperature/Humidity",
      value: "-10°C ~ +40°C/10% ~ 80% RH",
    },
    {
      label: "Storage Temperature/Humidity",
      value: "-20°C ~ +60°C/10% ~ 80% RH",
    },
    { label: "IP Rating", value: "IP30" },
    { label: "Lifetime", value: "100,000 hours" },
    { label: "Service Access", value: "Front" },
  ],
  "1.25mm": [
    { label: "Pixel Pitch (mm)", value: "1.25mm" },
    { label: "Resolution (per cabinet)", value: "480*270" },
    {
      label: "Product Dimensions (mm, per cabinet)",
      value: "600 x 337.5 x 40",
    },
    { label: "Modules Array (W x H, per cabinet)", value: "4 x 1" },
    { label: "Weight (per cabinet)", value: "W6.5kg" },
    { label: "Aspect Ratio", value: "16:9" },
    { label: "Brightness (nits)", value: "600-800" },
    { label: "Contrast Ratio (typ)", value: "7000:1" },
    { label: "LED Pixel Type", value: "SMD1010 1R1G1B LED" },
    { label: "Viewing Angle", value: "160° H/V" },
    { label: "Cabinet Material", value: "Die-Casting Aluminum" },
    { label: "Color Temperature", value: "3200-9300K Adjustable" },
    { label: "Power Consumption - Max", value: "<650w/m²" },
    { label: "Power Consumption - Avg", value: "<150w/m²" },
    { label: "Input Power Voltage", value: "100-240VAC, 50/60Hz" },
    { label: "Power Redundancy", value: "Available" },
    { label: "Video Rate", value: "30-120Hz" },
    { label: "Refresh Rate", value: "1920~3840Hz" },
    { label: "Control System", value: "ATE IPS System" },
    { label: "Color Depth", value: "14-18 bit" },
    {
      label: "Operational Temperature/Humidity",
      value: "-10°C ~ +40°C/10% ~ 80% RH",
    },
    {
      label: "Storage Temperature/Humidity",
      value: "-20°C ~ +60°C/10% ~ 80% RH",
    },
    { label: "IP Rating", value: "IP30" },
    { label: "Lifetime", value: "100,000 hours" },
    { label: "Service Access", value: "Front" },
  ],
  "1.56mm": [
    { label: "Pixel Pitch (mm)", value: "1.56mm" },
    { label: "Resolution (per cabinet)", value: "384*216" },
    {
      label: "Product Dimensions (mm, per cabinet)",
      value: "600 x 337.5 x 40",
    },
    { label: "Modules Array (W x H, per cabinet)", value: "4 x 1" },
    { label: "Weight (per cabinet)", value: "W6.5kg" },
    { label: "Aspect Ratio", value: "16:9" },
    { label: "Brightness (nits)", value: "600-800" },
    { label: "Contrast Ratio (typ)", value: "7000:1" },
    { label: "LED Pixel Type", value: "SMD1212 1R1G1B LED" },
    { label: "Viewing Angle", value: "160° H/V" },
    { label: "Cabinet Material", value: "Die-Casting Aluminum" },
    { label: "Color Temperature", value: "3200-9300K Adjustable" },
    { label: "Power Consumption - Max", value: "<650w/m²" },
    { label: "Power Consumption - Avg", value: "<150w/m²" },
    { label: "Input Power Voltage", value: "100-240VAC, 50/60Hz" },
    { label: "Power Redundancy", value: "Available" },
    { label: "Video Rate", value: "30-120Hz" },
    { label: "Refresh Rate", value: "1920-3840Hz" },
    { label: "Control System", value: "ATE IPS System" },
    { label: "Color Depth", value: "14-18 bit" },
    {
      label: "Operational Temperature/Humidity",
      value: "-10°C ~ +40°C/10% ~ 80% RH",
    },
    {
      label: "Storage Temperature/Humidity",
      value: "-20°C ~ +60°C/10% ~ 80% RH",
    },
    { label: "IP Rating", value: "IP30" },
    { label: "Lifetime", value: "100,000 hours" },
    { label: "Service Access", value: "Front" },
  ],
};

export default inertiaLEDProductSpecs;
